module.exports = __webpack_public_path__ + "img/cinet.a34060ae.svg";